import { Link } from "react-router-dom";

type Crumb = { label: string; to?: string };

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑" className="w-full">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
        {items.map((c, i) => {
          const last = i === items.length - 1;
          return (
            <li key={c.label} className="flex items-center gap-1.5">
              {last ? (
                <span aria-current="page" className="text-foreground-800">
                  {c.label}
                </span>
              ) : (
                <>
                  <Link to={c.to ?? "/"} className="transition-colors hover:text-primary-700">
                    {c.label}
                  </Link>
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}